import { render } from "./DiscountGroupsList.vue?vue&type=template&id=c58c62f2&scoped=true"
import script from "./DiscountGroupsList.vue?vue&type=script&lang=js"
export * from "./DiscountGroupsList.vue?vue&type=script&lang=js"

import "./DiscountGroupsList.vue?vue&type=style&index=0&id=c58c62f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c58c62f2"]])

export default __exports__